import React, { useEffect, useRef, useState } from "react";
import {
  ModalBackground,
  ModalContainer,
  ModalContainerSlide,
  ModalContent,
  ModalContentFade,
} from "./Modal.styles";

const Modal = ({
  open,
  children,
  width,
  close,
  height,
  padding,
  backgroundColor,
  background,
  type,
  border,
  right,
}) => {
  const modalContentRef = useRef(null);
  const [isVisible, setIsVisible] = useState(open);

  const handleBackgroundClick = (e) => {
    if (!modalContentRef.current.contains(e.target)) {
      close();
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleKeyDown = (e) => {
    if (type) {
      if (e.key === "Escape") {
        close({ state: false, type });
      }
    } else {
      if (e.key === "Escape") {
        close(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  useEffect(() => {
    let timer;
    if (open) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => setIsVisible(false), 250);
    }

    return () => clearTimeout(timer);
  }, [open]);

  useEffect(() => {
    if (isVisible) {
      document.documentElement.style.overflowY = "hidden";
      document.documentElement.style.paddingRight = "5px";
    } else {
      document.documentElement.style.overflowY = "scroll";
      document.documentElement.style.paddingRight = "0px";
    }
  }, [isVisible]);

  return (
    isVisible && (
      <ModalBackground $open={open} onClick={handleBackgroundClick}>
        {right ? (
          <ModalContainerSlide>
            <ModalContent
              ref={modalContentRef}
              $open={open}
              style={{
                height: height,
                width: width,
                padding: padding,
                border: border,
                backgroundColor: backgroundColor,
                background: background,
              }}
            >
              {children}
            </ModalContent>
          </ModalContainerSlide>
        ) : (
          <ModalContainer $center>
            <ModalContentFade
              ref={modalContentRef}
              $open={open}
              style={{
                height: height,
                width: width,
                padding: padding,
                border: border,
                backgroundColor: backgroundColor,
                background: background,
              }}
            >
              {children}
            </ModalContentFade>
          </ModalContainer>
        )}
      </ModalBackground>
    )
  );
};

export default Modal;
